import React from 'react';
import TooltipBody from 'modules/emergencies/components/ui/texts/TooltipBody';
import TooltipHeader from 'modules/emergencies/components/ui/texts/TooltipHeader';

export const CommentTooltip = ({ ticket }) => {
  const comment = ticket?.quote?.operation_details?.details;
  const head = comment ? 'Planning comment' : 'No comments yet';
  const body = comment;
  return (
    <>
      <TooltipHeader>{head}</TooltipHeader>
      {comment && <TooltipBody>{body}</TooltipBody>}
    </>
  );
};
